<template>
  <label
    class="c-switcher"
  >
    <input
      v-model="isChecked"
      class="c-switcher__input"
      :class="inputClasses"
      type="checkbox"
      @click="toggle"
    >
    <span class="c-switcher__slider" />
  </label>
</template>

<script>
export default {
  name: 'CoreSwitcher',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['toggle'],

  data () {
    return {
      isChecked: false,
    }
  },

  computed: {
    inputClasses () {
      return {
        'c-switcher__input--checked': this.isChecked,
      }
    },
  },

  mounted () {
    this.isChecked = this.value
  },

  methods: {
    toggle () {
      this.isChecked = !this.isChecked
      this.$emit('toggle', this.isChecked)
    },
  },
}
</script>

<style lang="scss">
.c-switcher {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  flex-shrink: 0;

  &__input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: map-get($colors, 'gray_8');
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 24px;

    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: map-get($colors, 'white');
      -webkit-transition: .4s;
      transition: .4s;
      border-radius: 50%;
    }
  }

  &__input--checked + &__slider {
    background-color: map-get($colors, 'default');
  }

  &__input--checked + &__slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }
}
</style>
